export default __webpack_public_path__ + "static/media/notification.bb4b9a27.svg";